import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import qs from 'qs';

import { withStyles } from '@material-ui/core/styles';
import withTheme from '@material-ui/core/styles/withTheme';
import withWidth from '@material-ui/core/withWidth';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';

import { reduxForm, formValueSelector } from 'redux-form';

import IconButton from 'components/common/IconButton';
import IconMagnifier from 'components/icons/IconMagnifier';
import IconCross from 'components/icons/IconCross';
import IconRefresh from 'components/icons/IconRefresh';
import IconFilter from 'components/icons/IconFilter';

import ClaimsFilterParameters from './ClaimsFilterParameters';
import ClaimsFilterSearch from './ClaimsFilterSearch';
import ClaimsFilterExpansionSummary from './ClaimsFilterExpansionSummary';
import ClaimsFilterExpansionDetails from './ClaimsFilterExpansionDetails';

const styles = theme => ({
  root: {
    position: 'sticky',
    marginBottom: 16,
    top: 64,
    zIndex: 21,
    [theme.breakpoints.down('sm')]: {
      top: 72,
      marginBottom: 8,
    },
  },
  paper: {
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  gridItemShrink: {
    flexShrink: 1,
  },
  toolbar: {
    padding: 8,
    [theme.breakpoints.down('sm')]: {
      padding: 8,
    },
  },
  parametersForm: {
    position: 'relative',
    paddingLeft: 24,
    '&:before': {
      content: '""',
      position: 'absolute',
      display: 'block',
      width: 1,
      height: 44,
      top: '50%',
      left: 20,
      transform: 'translateY(-50%)',
      backgroundColor: theme.palette.primary.A100,
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingTop: 8,
      '&:before': {
        display: 'none',
      },
    },
  },
  searchForm: {
    width: '100%',
  },
  iconMagnifier: {
    width: 18,
    height: 18,
    color: theme.palette.secondary[650],
  },
  iconCross: {
    width: 14,
    height: 14,
  },
  iconRefresh: {
    display: 'block',
    width: 16,
    height: 16,
    margin: '0 16px 0 20px',
    color: theme.palette.secondary[650],
  },
  buttonClear: {
    marginTop: -5,
    marginBottom: -5,
  },
  mobileButtonCounterContainer: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  buttonFilterWithCounter: {
    marginLeft: -10,
    marginBottom: -14,
    marginTop: -16,
  },
  buttonFilter: {
    display: 'none',
    marginLeft: -10,
    marginBottom: -14,
    marginTop: -12,
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  buttonFilterActive: {
    color: theme.palette.primary[500],
  },
  iconFilter: {
    width: 16,
    height: 16,
  },
  mobileSearchRow: {
    width: '100%',
  },
  collapseContainer: {
    marginLeft: -8,
    marginRight: -8,
    paddingLeft: 8,
    paddingRight: 8,
  },
  collapseEntered: {
    overflow: 'visible',
  },
  gridItemExpansionSummary: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});

function onChange(values, dispatch, props, prevValues) {
  const {
    User,
    Payer,
    'Order Status': OrderStatus,
    'Claim Status': ClaimStatus,
    'Check Number': CheckNumber,
    Filters,
    ...otherValues
  } = values;
  const params = qs.parse(props.router.location.search, { ignoreQueryPrefix: true });
  if (params.ID || params['check-number']) {
    props.history.replace(props.location.pathname);
  }
  if (Filters
    && (!Filters.User || Filters.User.length === 0)
    && (!Filters.Payer || Filters.Payer.length === 0)
    && (!Filters['Order Status'] || Filters['Order Status'].length === 0)
    && (!Filters['Claim Status'] || Filters['Claim Status'].length === 0)
    && (!Filters['Check Number'] || Filters['Check Number'].length === 0)
    && (!Filters['Date of Creation'] || Filters['Date of Creation'].length === 0)
    && (!Filters['Date of Service'] || Filters['Date of Service'].length === 0)
  ) {
    props.clearFields(false, false, 'Filters');
    props.clearFields(false, false, 'Date of Creation From');
    props.clearFields(false, false, 'Date of Creation To');
    props.clearFields(false, false, 'Date of Service From');
    props.clearFields(false, false, 'Date of Service To');
  }
  if (User) {
    props.clearFields(false, false, 'User');
    let newUsers;
    if (!Filters
      || !Filters.User) {
      newUsers = User;
    } else {
      newUsers = User.filter(newItem => Filters.User.findIndex(currentItem =>
        currentItem.value === newItem.value) === -1);
    }
    if (newUsers.length > 0) {
      newUsers.forEach((newItem) => {
        props.array.push('Filters.User', newItem);
      });
    }
  }
  if (Payer) {
    props.clearFields(false, false, 'Payer');
    let newPayers;
    if (!Filters
      || !Filters.Payer) {
      newPayers = Payer;
    } else {
      newPayers = Payer.filter(newItem => Filters.Payer.findIndex(currentItem =>
        currentItem.value === newItem.value) === -1);
    }
    if (newPayers.length > 0) {
      newPayers.forEach((newItem) => {
        props.array.push('Filters.Payer', newItem);
      });
    }
  }
  if (OrderStatus) {
    props.clearFields(false, false, 'Order Status');
    let newOrderStatuses;
    if (!Filters
      || !Filters['Order Status']) {
      newOrderStatuses = OrderStatus;
    } else {
      newOrderStatuses = OrderStatus.filter(newItem =>
        Filters['Order Status'].findIndex(currentItem =>
          currentItem.value === newItem.value) === -1);
    }
    if (newOrderStatuses.length > 0) {
      newOrderStatuses.forEach((newItem) => {
        props.array.push('Filters.Order Status', newItem);
      });
    }
  }
  if (ClaimStatus) {
    props.clearFields(false, false, 'Claim Status');
    let newClaimStatuses;
    if (!Filters
      || !Filters['Claim Status']) {
      newClaimStatuses = ClaimStatus;
    } else {
      newClaimStatuses = ClaimStatus.filter(newItem =>
        Filters['Claim Status'].findIndex(currentItem =>
          currentItem.value === newItem.value) === -1);
    }
    if (newClaimStatuses.length > 0) {
      newClaimStatuses.forEach((newItem) => {
        props.array.push('Filters.Claim Status', newItem);
      });
    }
  }
  if (CheckNumber) {
    props.clearFields(false, false, 'Check Number');
    let newCheckNumbers;
    if (!Filters
      || !Filters['Check Number']) {
      newCheckNumbers = CheckNumber;
    } else {
      newCheckNumbers = CheckNumber.filter(newItem =>
        Filters['Check Number'].findIndex(currentItem =>
          currentItem.value === newItem.value) === -1);
    }
    if (newCheckNumbers.length > 0) {
      newCheckNumbers.forEach((newItem) => {
        props.array.push('Filters.Check Number', newItem);
      });
    }
  }
  if (otherValues['Date of Creation From']
    && otherValues['Date of Creation To']
    && (otherValues['Date of Creation From'] !== prevValues['Date of Creation From']
    || otherValues['Date of Creation To'] !== prevValues['Date of Creation To'])) {
    const dateOfCreationRange =
      `${otherValues['Date of Creation From']}-${otherValues['Date of Creation To']}`;
    if (!Filters
      || !Filters['Date of Creation']
      || Filters['Date of Creation'].findIndex(item => item.value === dateOfCreationRange) === -1) {
      props.array.removeAll('Filters.Date of Creation');
      props.array.push('Filters.Date of Creation', {
        value: dateOfCreationRange,
        label: dateOfCreationRange,
      });
    }
  }
  if (Filters && Filters['Date of Creation'] && Filters['Date of Creation'].length === 0) {
    props.clearFields(false, false, 'Date of Creation From');
    props.clearFields(false, false, 'Date of Creation To');
  }
  if (otherValues['Date of Service From']
    && otherValues['Date of Service To']
    && (otherValues['Date of Service From'] !== prevValues['Date of Service From']
    || otherValues['Date of Service To'] !== prevValues['Date of Service To'])) {
    const dateOfServiceRange =
      `${otherValues['Date of Service From']}-${otherValues['Date of Service To']}`;
    if (!Filters
      || !Filters['Date of Service']
      || Filters['Date of Service'].findIndex(item => item.value === dateOfServiceRange) === -1) {
      props.array.removeAll('Filters.Date of Service');
      props.array.push('Filters.Date of Service', {
        value: dateOfServiceRange,
        label: dateOfServiceRange,
      });
    }
  }
  if (Filters && Filters['Date of Service'] && Filters['Date of Service'].length === 0) {
    props.clearFields(false, false, 'Date of Service From');
    props.clearFields(false, false, 'Date of Service To');
  }
}

class ClaimsFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchView: props.initializeWithSearchView,
      expandedView: props.filtersLength > 0,
    };

    this.onSearchButtonClick = this.onSearchButtonClick.bind(this);
    this.onSearchCancelButtonClick = this.onSearchCancelButtonClick.bind(this);
    this.onExpansionChange = this.onExpansionChange.bind(this);
  }

  componentDidMount() {
    const { onExpansionChange } = this.props;
    onExpansionChange({
      expandedView: this.state.expandedView,
      expansionDetailsHeight: this.expansionDetailsRef.getBoundingClientRect().height,
    });
  }

  componentWillReceiveProps(nextProps) {
    const { filtersLength } = this.props;
    let newExpandedView = this.state.expandedView;
    if (nextProps.filtersLength === 0) {
      newExpandedView = false;
    } else if (filtersLength === 0 && nextProps.filtersLength > 0) {
      newExpandedView = true;
    }
    this.setState({ expandedView: newExpandedView });
  }

  componentDidUpdate(prevProps) {
    const { filtersLength, onExpansionChange, mobileFilterExpanded } = this.props;
    if (filtersLength !== prevProps.filtersLength
      || mobileFilterExpanded !== prevProps.mobileFilterExpanded) {
      onExpansionChange({
        expandedView: this.state.expandedView,
        expansionDetailsHeight: this.expansionDetailsRef.getBoundingClientRect().height,
      });
    }
  }

  onSearchButtonClick() {
    this.setState({ searchView: true });
  }

  onSearchCancelButtonClick() {
    const { clearFields } = this.props;
    this.setState({ searchView: false });
    clearFields(false, false, 'Patient Name / Patient ID');
  }

  onExpansionChange() {
    const { onExpansionChange, filtersLength } = this.props;
    const newExpandedView = !this.state.expandedView;
    if (filtersLength > 0) {
      this.setState({ expandedView: newExpandedView });
    }
    onExpansionChange({
      expandedView: newExpandedView,
      expansionDetailsHeight: this.expansionDetailsRef.getBoundingClientRect().height,
    });
  }

  render() {
    const {
      handleSubmit,
      contextFiltersOptions,
      filters,
      filtersLength,
      selectedUsers,
      selectedPayers,
      selectedOrderStatuses,
      selectedClaimStatuses,
      selectedCheckNumbers,
      width,
      theme,
      className,
      onMobileFilterBottonClick,
      onResetButtonClick,
      mobileFilterExpanded,
      count,
      loading,
      items,
      classes,
      ...otherProps
    } = this.props;
    const { searchView, expandedView } = this.state;
    const isMobileLayout = ['xs', 'sm'].indexOf(width) !== -1;
    const ExpansionDetailsComponent = (
      <ClaimsFilterExpansionDetails
        expanded={expandedView}
        expansionDetailsRef={(expansionDetailsRef) => {
          this.expansionDetailsRef = expansionDetailsRef;
        }}
        prefix={(
          <IconButton
            className={classes.buttonClear}
            onClick={() => {
              otherProps.reset();
              otherProps.change('initialized', true);
              onResetButtonClick();
            }}
            disabled={otherProps.pristine}
            tooltipContent="Clear all filters"
            tooltipPlacement="right"
          >
            <IconRefresh className={classes.iconRefresh} />
          </IconButton>
        )}
      />
    );
    return (
      <div className={classNames(classes.root, className)}>
        <Paper className={classes.paper}>
          <form
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <Toolbar
              className={classes.toolbar}
              disableGutters
            >
              <Grid
                container
                justify="space-between"
                alignItems="center"
                wrap={isMobileLayout ? 'wrap' : 'nowrap'}
                spacing={0}
              >
                {searchView ? (
                  <Fragment>
                    <Grid item>
                      <IconButton
                        onClick={this.onSearchCancelButtonClick}
                        tooltipContent="Cancel"
                      >
                        <IconCross className={classes.iconCross} />
                      </IconButton>
                    </Grid>
                    <Grid
                      className={classes.gridItemShrink}
                      item
                      xs={12}
                    >
                      <ClaimsFilterSearch
                        className={classes.searchForm}
                        width={width}
                      />
                    </Grid>
                  </Fragment>
                ) : (
                  <Fragment>
                    {isMobileLayout ? (
                      <Fragment>
                        <Grid item xs={5}>
                          <div className={classes.mobileButtonCounterContainer}>
                            <IconButton
                              onClick={onMobileFilterBottonClick}
                              className={classNames(classes.buttonFilterWithCounter, {
                                [classes.buttonFilterActive]: filters && Object.keys(filters).length > 0,
                              })}
                            >
                              <IconFilter className={classes.iconFilter} />
                            </IconButton>
                            <Typography>
                              Claims
                              {(loading === 0 || items.length > 0) && (
                                ` (${count})`
                              )}
                            </Typography>
                          </div>
                        </Grid>
                        <Grid className={classes.mobileSearchRow} item xs={7}>
                          <ClaimsFilterSearch className={classes.searchForm} width={width} />
                        </Grid>      
                        <Grid item xs={12}>
                          <Collapse
                            in={mobileFilterExpanded}
                            classes={{
                              container: classes.collapseContainer,
                              entered: classes.collapseEntered,
                            }}
                            timeout={theme.transitions.duration.short}
                          >
                            <ClaimsFilterParameters
                              className={classes.parametersForm}
                              selectedUsers={selectedUsers}
                              selectedPayers={selectedPayers}
                              selectedOrderStatuses={selectedOrderStatuses}
                              selectedClaimStatuses={selectedClaimStatuses}
                              selectedCheckNumbers={selectedCheckNumbers}
                              contextFiltersOptions={contextFiltersOptions}
                              width={width}
                              {...otherProps}
                            />
                          </Collapse>
                        </Grid>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <Grid
                          className={classes.gridItemShrink}
                          item
                          xs={12}
                        >
                          <Grid
                            container
                            justify="space-between"
                            alignItems="center"
                            wrap="nowrap"
                            spacing={0}
                          >
                            <Grid item>
                              <IconButton
                                onClick={this.onSearchButtonClick}
                                tooltipContent="Search by Patient Name or PRN"
                              >
                                <IconMagnifier className={classes.iconMagnifier} />
                              </IconButton>
                            </Grid>
                            <Grid
                              className={classes.gridItemShrink}
                              item
                              xs={12}
                            >
                              <ClaimsFilterParameters
                                className={classes.parametersForm}
                                selectedUsers={selectedUsers}
                                selectedPayers={selectedPayers}
                                selectedOrderStatuses={selectedOrderStatuses}
                                selectedClaimStatuses={selectedClaimStatuses}
                                selectedCheckNumbers={selectedCheckNumbers}
                                contextFiltersOptions={contextFiltersOptions}
                                width={width}
                                {...otherProps}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid className={classes.gridItemExpansionSummary} item>
                          <ClaimsFilterExpansionSummary
                            expanded={expandedView}
                            onChange={this.onExpansionChange}
                            filtersLength={filtersLength}
                          />
                        </Grid>
                      </Fragment>
                    )}
                  </Fragment>
                )}
              </Grid>
            </Toolbar>
            {isMobileLayout ? (
              <Collapse
                in={mobileFilterExpanded}
                timeout={theme.transitions.duration.short}
              >
                {ExpansionDetailsComponent}
              </Collapse>
            ) : ExpansionDetailsComponent}
          </form>
        </Paper>
      </div>
    );
  }
}

ClaimsFilter.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  array: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  clearFields: PropTypes.func.isRequired,
  initialized: PropTypes.bool.isRequired,
  initializeWithSearchView: PropTypes.bool.isRequired,
  filtersLength: PropTypes.number.isRequired,
  selectedUsers: PropTypes.arrayOf(PropTypes.number),
  selectedPayers: PropTypes.arrayOf(PropTypes.number),
  selectedOrderStatuses: PropTypes.arrayOf(PropTypes.number),
  selectedClaimStatuses: PropTypes.arrayOf(PropTypes.string),
  selectedCheckNumbers: PropTypes.arrayOf(PropTypes.number),
  account: PropTypes.shape({
    ID: PropTypes.number.isRequired,
    'First Name': PropTypes.string.isRequired,
    'Last Name': PropTypes.string.isRequired,
  }).isRequired,
  contextFiltersOptions: PropTypes.shape({
    orderStatuses: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      count: PropTypes.number,
    })).isRequired,
  }),
  classes: PropTypes.shape({
    gridItemShrink: PropTypes.string.isRequired,
    root: PropTypes.string.isRequired,
    toolbar: PropTypes.string.isRequired,
    parametersForm: PropTypes.string.isRequired,
    searchForm: PropTypes.string.isRequired,
    iconMagnifier: PropTypes.string.isRequired,
    iconCross: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
  onResetButtonClick: PropTypes.func,
  onExpansionChange: PropTypes.func,
  filters: PropTypes.object,
  count: PropTypes.number,
  loading: PropTypes.number,
  items: PropTypes.arrayOf(PropTypes.object),
  width: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  router: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

ClaimsFilter.defaultProps = {
  selectedUsers: [],
  selectedPayers: [],
  selectedOrderStatuses: [],
  selectedClaimStatuses: [],
  selectedCheckNumbers: [],
  contextFiltersOptions: null,
  className: '',
  onResetButtonClick: () => {},
  onExpansionChange: () => {},
  filters: null,
  count: 0,
  loading: 0,
  items: [],
};

const mapStateToProps = (store, ownProps) => {
  const selector = formValueSelector(ownProps.form);
  const patientNameIDValue = selector(store, 'Patient Name / Patient ID');
  const filterValues = selector(store, 'Filters');
  const filtersKeys = filterValues ? Object.keys(filterValues) : null;
  return {
    filtersLength: filtersKeys
      ? filtersKeys.reduce((accumulator, filtersKey) =>
        accumulator + filterValues[filtersKey].length, 0)
      : 0,
    initializeWithSearchView: Boolean(patientNameIDValue),
    selectedUsers: filterValues && filterValues.User
      ? filterValues.User.map(item => item.value) : [],
    selectedPayers: filterValues && filterValues.Payer
      ? filterValues.Payer.map(item => item.value) : [],
    selectedOrderStatuses: filterValues && filterValues['Order Status']
      ? filterValues['Order Status'].map(item => item.value) : [],
    selectedClaimStatuses: filterValues && filterValues['Claim Status']
      ? filterValues['Claim Status'].map(item => item.value) : [],
    selectedCheckNumbers: filterValues && filterValues['Check Number']
      ? filterValues['Check Number'].map(item => item.value) : [],
    account: store.account,
    filters: ownProps.filters || null,
    router: store.router,
  };
};

export default connect(mapStateToProps)(withRouter(reduxForm({
  onSubmit: values => values,
  onChange,
  keepDirtyOnReinitialize: true,
})(
  withStyles(styles)(withWidth()(withTheme()(ClaimsFilter))),
)));



// WEBPACK FOOTER //
// ./src/components/reports/ClaimsFilter/ClaimsFilter.js